import * as React from 'react'
import { useDispatch } from 'react-redux'
import { setIsStored } from '../../../redux/slices/Alerts'
import { Box, Paper, Divider, Grid, CircularProgress, Typography } from '@mui/material'
import { datasetFormik, ROLE_FIELD_NAME } from './datasetFormik'
import { Formik, Form } from 'formik'
import BottonInside from '../../BottonCustom/BottonInside'
import Textfield from '../../FormsUI/Textfield'
import * as service from '../../../services'
import Modal from '../../FormCreationModal'
import Select from '../../FormsUI/Select'

const gridStyle = {
  mt: 0,
  width: '100%',
  ml: 0,
  textAlignLast: 'right',
  justifyContent: 'space-evenly',
  pr: 2,
}

const UserFormModal = (props, ref) => {
  const dispatch = useDispatch()
  const [formik, setFormik] = React.useState(null)
  const [open, setOpen] = React.useState(false)
  const [loadingRoles, setLoadingRoles] = React.useState(false)

  const handleCancelAction = () => setOpen(false)

  // Un 400 de validación trae `errors`; un 409, 422 o 500, `message`.
  const getCreateUserError = response =>
    response?.errors?.[0]?.msg || response?.message || 'No se pudo crear el usuario.'

  const handleAddAction = async values => {
    const { username, lastname, email, phone_code, phone_number, roleId } = values
    const phoneNumber = phone_number.trim()
    const payload = {
      nombre: username.trim(),
      apellido: lastname.trim(),
      email: email.trim().toLowerCase(),
      idRol: roleId,
      ...(phoneNumber ? { celular: `${phone_code}${phoneNumber}` } : {}),
    }

    const response = await service.createUserByAdmin(payload)
    if (!response?.created)
      return { stored: false, severity: 'error', message: getCreateUserError(response) }

    return {
      stored: true,
      severity: response.emailSent ? 'success' : 'warning',
      message: response.message,
    }
  }

  const otherPropsControl = {
    InputProps: { readOnly: false },
    variant: 'outlined',
  }

  React.useImperativeHandle(ref, () => ({ openModal: () => setOpen(true) }))

  React.useEffect(() => {
    if (!open) return
    let isMounted = true
    const TOKEN = `Bearer ${window.localStorage.getItem('ArbolEc_token')}`

    const loadForm = async () => {
      setLoadingRoles(true)
      setFormik(null)
      try {
        const rolesResponse = await service.getRole(TOKEN)
        const roles = rolesResponse?.roles || []
        const roleOptions = roles.reduce((acc, role) => {
          acc[String(role.id_r)] = role.tipo
          return acc
        }, {})
        if (!isMounted) return
        setFormik(datasetFormik(roleOptions))
      } catch (err) {
        if (!isMounted) return
        setFormik(datasetFormik({}))
      } finally {
        if (isMounted) setLoadingRoles(false)
      }
    }

    loadForm()

    return () => {
      isMounted = false
      setFormik(null)
    }
  }, [open])

  if (!Boolean(formik)) {
    return (
      <Modal
        open={open}
        title="Crear usuario"
        description="Registre un nuevo usuario y asigne su rol de acceso.">
        <Box sx={{ py: 3, display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress size={18} />
          <Typography variant="body2" color="text.secondary">
            Cargando formulario...
          </Typography>
        </Box>
      </Modal>
    )
  }

  const roleField = formik.ITEMS_USER_FORMIK.find(item => item.name === ROLE_FIELD_NAME)
  const hasRoleOptions = Object.keys(roleField?.options || {}).length > 0

  return (
    <Modal
      open={open}
      title="Crear usuario"
      description="Registre un nuevo usuario y asigne su rol de acceso.">
      <Box>
        <Formik
          initialValues={{ ...formik?.INITIAL_FORMIK_STATE }}
          validationSchema={formik?.FORM_VALIDATION}
          onSubmit={async values => {
            const result = await handleAddAction(values)
            if (result?.stored) handleCancelAction()
            dispatch(setIsStored(result))
          }}>
          <Form>
            <Paper
              style={{
                height: '100%',
                overflow: 'auto',
                borderRadius: 0,
              }}>
              <Divider />
              <Grid container spacing={2} sx={{ ...gridStyle }}>
                {formik?.ITEMS_USER_FORMIK.map((item, idx) => {
                  const child = !item.options ? (
                    <Textfield {...otherPropsControl} {...item} />
                  ) : (
                    <Select key={`InPut-${idx}`} {...item} {...otherPropsControl} />
                  )
                  return (
                    <Grid
                      key={`InPut-${idx}`}
                      item
                      xs={item.x}
                      sx={{ textAlignLast: 'center' }}>
                      {child}
                    </Grid>
                  )
                })}
              </Grid>
              <Divider sx={{ pt: 2 }} />
              <BottonInside
                enableButton={!loadingRoles && hasRoleOptions}
                hdleButtonCancel={handleCancelAction}
              />
            </Paper>
          </Form>
        </Formik>
      </Box>
    </Modal>
  )
}

export default React.forwardRef(UserFormModal)
